import script from "./inventoryDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./inventoryDetail.vue?vue&type=script&setup=true&lang=ts"

import "./inventoryDetail.vue?vue&type=style&index=0&id=f0e4c090&lang=scss"
import "./inventoryDetail.vue?vue&type=style&index=1&id=f0e4c090&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0e4c090"]])

export default __exports__